import { render } from "./OcrVerificationForm.vue?vue&type=template&id=2bfb480c&scoped=true"
import script from "./OcrVerificationForm.vue?vue&type=script&lang=js"
export * from "./OcrVerificationForm.vue?vue&type=script&lang=js"

import "./OcrVerificationForm.vue?vue&type=style&index=0&id=2bfb480c&lang=scss"
import "./OcrVerificationForm.vue?vue&type=style&index=1&id=2bfb480c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfb480c"]])

export default __exports__